import { render, staticRenderFns } from "./FinalComments.vue?vue&type=template&id=6ac57866&"
import script from "./FinalComments.vue?vue&type=script&lang=js&"
export * from "./FinalComments.vue?vue&type=script&lang=js&"
import style0 from "./FinalComments.vue?vue&type=style&index=0&soped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports